import React from 'react'

type Props = {
  number?: number
}

const Counter: React.FC<Props> = ({ number }) => {
  if (!number || number <= 0) return null
  return (
    <div className="bg-secondary text-white rounded-full h-5 w-5 text-xs flex items-center justify-center">
      {number}
    </div>
  )
}

export default Counter
